import React, { Component } from 'react';

  

class Footer extends Component {

 
    render() {
        return (
            <div className="footer2">
 <div class="wrapper">
  <div class="icon facebook">
    <div class="tooltip">Facebook</div>
    <span><i > <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/Facebook_icon.svg/1200px-Facebook_icon.svg.png"  width="35px" alt="icon"/></i></span>
  </div>
  <div class="icon twitter">
    <div class="tooltip">Twitter</div>
    <span><i class="fab fa-twitter"> <img src="https://ra.ac.ae/wp-content/uploads/2020/01/logo-twitter-icon-symbol-0.png"  width="35px" alt="icon"/></i></span>
  </div>
  <div class="icon instagram">
    <div class="tooltip">Instagram</div>
    <span><i class="fab fa-instagram"> <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Instagram-Icon.png/1025px-Instagram-Icon.png"  width="35px" alt="icon"/></i></span>
  </div>
  <div class="icon github">
    <div class="tooltip">Github</div>
    <span><i class="fab fa-github"> <img src="https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"  width="35px" alt="icon"/></i></span>
  </div>
  <div class="icon youtube">
    <div class="tooltip">Youtube</div>
    <span><i class="fab fa-youtube"> <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/640px-YouTube_full-color_icon_%282017%29.svg.png"  width="35px" alt="icon"/></i></span>
  </div>
</div> 
            </div>
        )
    }
}

export default Footer
